export const CONTRACTS_NAMES = {
  PERIOD: 'PERIOD',
  MASHING: 'MASHING',
  WASH: 'WASH',
  SPIRIT: 'SPIRIT',
  ADMIN: 'ADMIN'
};

export const CONTRACTS_EVENTS = {
  PERIOD_ADDED: 'periodAdded',
  MASHING_ADDED: 'mashingAdded',
  MASHING_UPDATED: 'mashingUpdated',
  WASH_ADDED: 'washAdded',
  WASH_UPDATED: 'washUpdated',
  SPIRIT_ADDED: 'spiritAdded',
  SPIRIT_UPDATED: 'spiritUpdated'
};

export const CONTRACTS_FUNCTIONS = {
  ADD_PERIOD: 'addPeriod',
  ADD_MASHING: 'addMashing',
  UPDATE_MASHING: 'updateMashing',
  ADD_WASH: 'addWash',
  UPDATE_WASH: 'updateWash',
  ADD_SPIRIT: 'addSpirit',
  UPDATE_SPIRIT: 'updateSpirit',
  ADD_ADMIN: 'addAdmin'
};

export const CONTRACTS = Object.values(CONTRACTS_NAMES).reduce(
  (previousValues, currentValue) => ({
    ...previousValues,
    [currentValue]: {
      ADDRESS: process.env[`REACT_APP_${currentValue}_CONTRACT_ADDRESS`]
    }
  }),
  {}
);
